import { render, staticRenderFns } from "./CompanyContactsTable.vue?vue&type=template&id=d8079bba&scoped=true&"
import script from "./CompanyContactsTable.vue?vue&type=script&lang=ts&"
export * from "./CompanyContactsTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8079bba",
  null
  
)

export default component.exports